import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'plSlice' })
export class PlSlicePipe implements PipeTransform {
  public transform(valueToTruncate: string | undefined | null, maxLength: number = 500): string {
    if (valueToTruncate) {
      if (valueToTruncate.length > maxLength) {
        return `${valueToTruncate.slice(0, maxLength)}...`;
      } else {
        return valueToTruncate;
      }
    }

    return '';
  }
}
